async function readFile(file) {
  const result = await new Promise((resolve) => {
    let fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.readAsBinaryString(file);
  });

  return result;
}

export { readFile };
